import React from "react";

const formatSize = (size) => {
  const value = Number(size || 0);
  if (value > 1024 * 1024) return `${(value / 1024 / 1024).toFixed(1)} MB`;
  if (value > 1024) return `${(value / 1024).toFixed(1)} KB`;
  return `${value} B`;
};

const formatTime = (stamp) => {
  if (!stamp) return "-";
  try {
    return new Date(Number(stamp) * 1000).toLocaleString("ko-KR");
  } catch {
    return "-";
  }
};

function DevConsolePanel({
  roots,
  cwd,
  parentPath,
  items,
  selectedFile,
  fileContent,
  command,
  commandOutput,
  busy,
  notice,
  onLoadRoots,
  onOpenDir,
  onOpenFile,
  onContentChange,
  onSaveFile,
  onCommandChange,
  onRunCommand,
}) {
  return (
    <section className="dev-console-panel">
      <div className="deployment-history-header">
        <div>
          <p className="panel-kicker">SERVER DEV CONSOLE</p>
          <h3>서버 개발 콘솔</h3>
          <span>서버 파일을 열어 수정하고, 현재 경로에서 명령어를 실행하는 관리자 전용 작업 화면입니다.</span>
        </div>
        <div className="dev-console-actions">
          <button className="admin-approve-button" type="button" disabled={busy} onClick={onLoadRoots}>루트 새로고침</button>
          <button className="admin-approve-button" type="button" disabled={busy} onClick={() => onOpenDir(cwd)}>목록 새로고침</button>
        </div>
      </div>

      {notice && <div className="admin-inline-notice"><span>{notice}</span></div>}

      <div className="dev-console-layout">
        <aside className="dev-console-browser">
          <div className="dev-console-section-title">
            <strong>접속 루트</strong>
            <span>{roots?.length || 0}</span>
          </div>
          <div className="dev-console-root-list">
            {(roots || []).map((root) => (
              <button key={root.path} type="button" className={cwd === root.path ? "active" : ""} onClick={() => onOpenDir(root.path)}>
                <strong>{root.path}</strong>
                <span>{root.exists ? "사용 가능" : "없음"}</span>
              </button>
            ))}
          </div>

          <div className="dev-console-pathbar">
            <code>{cwd}</code>
            <button type="button" disabled={busy || !parentPath || parentPath === cwd} onClick={() => onOpenDir(parentPath)}>상위</button>
          </div>

          <div className="dev-console-file-list">
            {(items || []).map((item) => (
              <button
                key={item.path}
                type="button"
                className={`${item.type === "directory" ? "folder" : "file"} ${selectedFile?.path === item.path ? "active" : ""}`}
                onClick={() => item.type === "directory" ? onOpenDir(item.path) : onOpenFile(item.path)}
              >
                <span>{item.type === "directory" ? "[DIR]" : "[FILE]"}</span>
                <strong>{item.name}</strong>
                <small>{item.type === "directory" ? "folder" : formatSize(item.size)} · {formatTime(item.modified_at)}</small>
              </button>
            ))}
            {!items?.length && <div className="dev-console-empty">파일 목록이 없습니다.</div>}
          </div>
        </aside>

        <div className="dev-console-workspace">
          <section className="dev-console-editor">
            <div className="dev-console-editor-head">
              <div>
                <strong>{selectedFile?.name || "파일을 선택하세요"}</strong>
                <span>{selectedFile?.path || "왼쪽 파일 목록에서 텍스트 파일을 열면 이곳에서 수정할 수 있습니다."}</span>
              </div>
              <button className="admin-danger-button" type="button" disabled={busy || !selectedFile} onClick={onSaveFile}>저장</button>
            </div>
            <textarea
              spellCheck="false"
              value={fileContent}
              onChange={(event) => onContentChange(event.target.value)}
              placeholder="파일 내용"
              disabled={!selectedFile}
            />
          </section>

          <section className="dev-console-terminal">
            <div className="dev-console-editor-head">
              <div>
                <strong>터미널</strong>
                <span>현재 경로 기준으로 명령어를 실행합니다. 실행 전 RUN 확인이 필요합니다.</span>
              </div>
              <button className="admin-danger-button" type="button" disabled={busy || !command.trim()} onClick={onRunCommand}>실행</button>
            </div>
            <div className="dev-console-command-row">
              <code>{cwd}</code>
              <input
                value={command}
                onChange={(event) => onCommandChange(event.target.value)}
                onKeyDown={(event) => {
                  if (event.ctrlKey && event.key === "Enter") onRunCommand();
                }}
                placeholder="예: ls -al, sudo systemctl status tobe-ai-backend --no-pager"
              />
            </div>
            <pre>{commandOutput || "명령 실행 결과가 여기에 표시됩니다."}</pre>
          </section>
        </div>
      </div>
    </section>
  );
}

export default DevConsolePanel;
